import React, { Context, JSX, ReactNode, createContext, useContext, useEffect, useMemo, useState } from 'react';

import { useLocation } from 'react-router-dom';

import offerService, { OfferResponse } from '../../../services/cruises/OfferService';

type Offer = OfferResponse['result'];

interface CruiseOfferByIdData {
  offer: Offer;
}

interface CruiseOfferByIdProviderProps {
  children?: ReactNode;
}

export const CruiseOfferByIdContext: Context<CruiseOfferByIdData> = createContext({} as CruiseOfferByIdData);

export function CruiseOfferByIdProvider({ children }: CruiseOfferByIdProviderProps): JSX.Element {
  const { pathname, search } = useLocation();
  const [offer, setOffer] = useState<Offer>(null);
  const offerId = useMemo(() => pathname.split('/').pop(), [pathname]);

  const allowInvalidOffer = useMemo(() => {
    const params = new URLSearchParams(search);
    return !!params.get('allowInvalidOffer');
  }, [search]);

  const getOfferById = async (id: string) => {
    const { result } = await offerService.getById(id, {
      allowInvalidOffer,
    });
    setOffer(result);
  };

  useEffect(() => {
    getOfferById(offerId);
  }, [offerId]);

  return <CruiseOfferByIdContext.Provider value={{ offer }}>{children}</CruiseOfferByIdContext.Provider>;
}

export const useCruiseOfferById = (): CruiseOfferByIdData => useContext(CruiseOfferByIdContext);
